module.exports = __webpack_public_path__ + "img/lemon-right-2.b744ee36.png";